"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDict = exports.zip = void 0;
exports.func_sum = func_sum;
exports.func_mean = func_mean;
exports.range = range;
exports.argMax = argMax;
exports.deepCopy = deepCopy;
exports.truncate = truncate;
exports.feel_list_with_values_if_empty = feel_list_with_values_if_empty;
exports.print = print;
exports.logInString = logInString;
exports.printOrLog = printOrLog;
exports.genStringFromArray = genStringFromArray;
exports.stringifyDictForShow = stringifyDictForShow;
exports.translate_dict_from_id_to_code = translate_dict_from_id_to_code;
exports.translate_dict_values_from_id_to_code = translate_dict_values_from_id_to_code;
exports.translate_whole_dict = translate_whole_dict;
exports.find_branches_in_objective = find_branches_in_objective;
var parametric_graph_1 = require("@evidenceb/parametric-graph");
/**
 * concatenate two arrays
 */
var zip = function (arr) {
    var arrs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        arrs[_i - 1] = arguments[_i];
    }
    return arr.map(function (val, i) { return arrs.reduce(function (a, arr) { return __spreadArray(__spreadArray([], a, true), [arr[i]], false); }, [val]); });
};
exports.zip = zip;
/**
 * fucntion sum an array
 */
function func_sum(array) {
    var sum1 = array.reduce(function (accumulator, currentValue) { return accumulator + currentValue; });
    return sum1;
}
/**
 * fucntion mean an array
 */
function func_mean(array) {
    var suma = 0;
    for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
        var x = array_1[_i];
        suma += x;
    }
    var mean = suma / array.length;
    return mean;
}
/**
 * generate a list of croissant integers
 */
function range(start, stop, step) {
    if (typeof stop == 'undefined') {
        // one param defined
        stop = start;
        start = 0;
    }
    if (typeof step == 'undefined') {
        step = 1;
    }
    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }
    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }
    return result;
}
/**
 * fucntion argMax of an array
 */
function argMax(array) {
    return array.map(function (x, i) { return [x, i]; }).reduce(function (r, a) { return (a[0] > r[0] ? a : r); })[1];
}
/**
 * fucntion deepCopy of an object
 */
function deepCopy(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj)
        return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = deepCopy(obj[attr]);
        }
        return copy;
    }
}
/**
 * fucntion truncate a number
 */
function truncate(val, low, high) {
    if (low === void 0) { low = 0; }
    if (high === void 0) { high = 1; }
    var truncatedVal = val;
    if (val < low) {
        truncatedVal = low;
    }
    else if (val > high) {
        truncatedVal = high;
    }
    return truncatedVal;
}
/**
 * function to feel a list with values if the list is empty
 */
function feel_list_with_values_if_empty(default_val, list_to_feel, number_of_value_to_feel) {
    if (list_to_feel.length == 0) {
        for (var i = 0; i < number_of_value_to_feel; i++)
            list_to_feel.push(default_val);
    }
    return list_to_feel;
}
function print(dataToPrint, toPrint, condToPrint) {
    if (toPrint && condToPrint) {
        if (Array.isArray(dataToPrint)) {
            dataToPrint = genStringFromArray(dataToPrint);
        }
        else {
            if (dataToPrint.constructor == Object) {
                dataToPrint = stringifyDictForShow(dataToPrint);
            }
        }
        console.log(dataToPrint);
    }
}
function logInString(dataToLog, toLog, condToLog, stringToLogIn) {
    if (toLog && condToLog && stringToLogIn != "") {
        if (Array.isArray(dataToLog)) {
            dataToLog = genStringFromArray(dataToLog);
        }
        stringToLogIn += '\n' + dataToLog;
    }
}
function printOrLog(dataToPrintOrLog, logParams, logEntry, logValue) {
    var toLog = logParams["toLogInFile"];
    var toPrint = logParams["toPrint"];
    var condToPrintOrLog = (logParams["toLog"][logEntry].includes(logValue));
    var stringToLogIn = logParams["stringToLogIn"];
    print(dataToPrintOrLog, toPrint, condToPrintOrLog);
    logInString(dataToPrintOrLog, toLog, condToPrintOrLog, stringToLogIn);
}
function genStringFromArray(arrayToString) {
    var myString = "";
    for (var _i = 0, arrayToString_1 = arrayToString; _i < arrayToString_1.length; _i++) {
        var str = arrayToString_1[_i];
        if (str.constructor == Object) {
            myString += "\n";
            myString += stringifyDictForShow(str);
        }
        else {
            myString += String(str);
            myString += " ";
        }
    }
    myString += "\n";
    return myString;
}
function stringifyDictForShow(dict) {
    var string = "";
    for (var key in dict) {
        string += key + ": " + JSON.stringify(dict[key]);
        string += "\n";
    }
    return string;
}
/**
     * Translate id into code for the keys (MxOxAx) with the map_id_code from config
     * @param dict dict to translate with id as keys
     * @returns new dict with code as keys
     */
function translate_dict_from_id_to_code(params, dict) {
    var dict_with_code = {};
    for (var key in dict) {
        dict_with_code[params["graph"]["graph"]["map_id_code"][key]] = dict[key];
    }
    return dict_with_code;
}
/**
 * translate id to code for the values
 * @param dict ict to translate with id as values
 * @returns new dict with code in values
 */
function translate_dict_values_from_id_to_code(params, dict) {
    var dict_with_code_values = {};
    for (var key in dict) {
        dict_with_code_values[key] = [];
        for (var _i = 0, _a = dict[key]; _i < _a.length; _i++) {
            var val = _a[_i];
            dict_with_code_values[key].push(params["graph"]["graph"]["map_id_code"][val]);
        }
    }
    return dict_with_code_values;
}
/**
 * translate id to code for the values and keys
 * @param dict ict to translate with id
 * @returns new dict with code in values and keys
 */
function translate_whole_dict(params, dict) {
    return translate_dict_values_from_id_to_code(params, translate_dict_from_id_to_code(params, dict));
}
/**
 * class pour faire des DefaultDict comme python
 * si dict[key] n'existe pas, initialise la valeur
 * @param defaultInit constructeur utilisé comme valeur à initialisé (new Array()...)
 */
var DefaultDict = /** @class */ (function () {
    function DefaultDict(defaultInit) {
        return new Proxy({}, {
            get: function (target, name) { return name in target ?
                target[name] :
                (target[name] = typeof defaultInit === 'function' ?
                    new defaultInit().valueOf() :
                    defaultInit); }
        });
    }
    return DefaultDict;
}());
exports.DefaultDict = DefaultDict;
function find_branches_in_objective(objId, zpdesGraph, parametricgraph) {
    var branches = {};
    var activities = zpdesGraph.graph.graph[objId].subgroups[0];
    var seen = [];
    for (var i = activities.length - 1; i > 0; i--) {
        if (!seen.includes(activities[i])) {
            var ancestors = (0, parametric_graph_1.getAncestors)(parametricgraph, activities[i]);
            ancestors = ancestors.filter(function (x) { return activities.includes(x); });
            branches[activities[i]] = ancestors;
            seen = seen.concat(ancestors);
            if (ancestors.length == activities.length) {
                break;
            }
        }
    }
    return branches;
}
